import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";

const getAuthToken = () => {
    const decryptedData = CryptoJS.AES.decrypt(localStorage.getItem("token"), CRYPTO_TOKEN_SECRET_KEY).toString(CryptoJS.enc.Utf8);
    return decryptedData;
};

export const getTenantRegistrationReportAction =
    async (params) => {
        const authToken = getAuthToken();

        const headers = {
            Authorization: `Bearer ${authToken}`,
        };

        return new Promise((resolve, reject) => {
            axios
                .get(
                    "/api/reports/tenant-registration-report",
                    {
                        params,
                        headers,
                    }
                )
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

export const getRevenueReportAction = async (data = {}) => {
    const authToken = getAuthToken();

    const headers = {
        Authorization: `Bearer ${authToken}`,
    };
    return new Promise((resolve, reject) => {
        axios
            .post("/api/reports/revenue", data, { headers })
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                reject(error.response?.data || error);
            });
    });
};

export const exportRevenueReportAction = (data) => {
    return new Promise((resolve, reject) => {
        let url = "/api/reports/exportRevenueReport";

        axios
            .post(url, data, {
                responseType: "blob",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getInvoiceReportAction = async (data = {}) => {
    const authToken = getAuthToken();
    const headers = {
        Authorization: `Bearer ${authToken}`,
    };
    return new Promise((resolve, reject) => {
        axios
            .post(
                "/api/reports/invoice",
                data,
                { headers }
            )
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                reject(
                    error.response?.data ||
                    error
                );
            });
    });
};

export const getTrialReportAction = async (data = {}) => {
    const authToken = getAuthToken();
    const headers = { Authorization: `Bearer ${authToken}` };

    return new Promise(
        (resolve, reject) => {
            axios
                .post(
                    "/api/reports/trial",
                    data,
                    { headers }
                )
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error.response?.data || error);
                });
        }
    );
};

export const getTransactionReportAction = async (data = {}) => {
    const authToken = getAuthToken();
    const headers = { Authorization: `Bearer ${authToken}` };
    return new Promise((resolve, reject) => {
        axios
            .post("/api/reports/transaction", data, { headers })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error.response?.data || error);
            });
    });
};

export const getFailedTransactionReportAction = async (data = {}) => {
    const authToken = getAuthToken();
    const headers = { Authorization: `Bearer ${authToken}` };

    return new Promise((resolve, reject) => {
        axios
            .post("/api/reports/failed-transaction", data, { headers })
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                reject(error.response?.data || error);
            });
    });
};

export const getProductPerformanceReportAction = async (data = {}) => {
    const authToken = getAuthToken();
    const headers = { Authorization: `Bearer ${authToken}` };

    return new Promise((resolve, reject) => {
        axios
            .post("/api/reports/product-performance-report", data,
                { headers }
            )
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                reject(error.response?.data || error);
            });
    });
};